import { observer } from 'mobx-react-lite'
import { ItemPreviewDesktop } from 'page/catalog/ItemPreview/ItemPreviewDesktop'
import { ItemPreviewMobile } from 'page/catalog/ItemPreview/ItemPreviewMobile'
import { ItemPreviewBasic } from 'page/catalog/ItemPreviewBasic/ItemPreviewBasic'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'

export const ItemPreviewModal = observer(() => {
  const { stand, basic } = useDemo()
  const { small } = ui.window

  if (basic) return <ItemPreviewBasic />
  else if (small || stand) return <ItemPreviewMobile />
  else return <ItemPreviewDesktop />
})
